import { Box, Typography } from '@mui/material';
import { ChartsAxisHighlight, ChartsLegend, ChartsTooltip, ChartsXAxis, ChartsYAxis, LinePlot } from '@mui/x-charts';
import { ResponsiveChartContainer } from '@mui/x-charts/ResponsiveChartContainer';
import { format } from 'date-fns';
import { BoxWithHeader } from '../common';
import { DealerAccidentsOverviewProps } from './types';
import { processData } from './utils/processData';

export const DealerAccidentsOverview = ({ graphData }: DealerAccidentsOverviewProps) => {
  const chartData = processData({ data: graphData });
  if (!chartData) return null;
  return (
    <BoxWithHeader
      title={
        <>
          <Typography variant="h6" fontWeight="bold">
            Můj přehled nehod v čase
          </Typography>
          <Typography variant="body2" color="gray">
            Přehled mých řešených a neřešených nehod v čase
          </Typography>
        </>
      }
    >
      <Box width={1} height="300px">
        <ResponsiveChartContainer
          skipAnimation
          margin={{ bottom: 130 }}
          series={[
            {
              type: 'line',
              data: chartData?.map((d) => d.accepted),
              label: 'Řešené nehody',
              color: 'green'
            },
            {
              type: 'line',
              data: chartData?.map((d) => d.rejected),
              label: 'Neřešené nehody',
              color: '#C62327'
            }
          ]}
          xAxis={[
            {
              data: chartData.map((d) => format(d.date, 'dd.MM.yyyy')),
              scaleType: 'band',
              id: 'x-axis-id'
            }
          ]}
          yAxis={[{ id: 'y-axis-id' }]}
        >
          <LinePlot />
          <ChartsYAxis label="Celkem" position="left" axisId="y-axis-id" />
          <ChartsXAxis label="Datum" position="bottom" axisId="x-axis-id" />
          <ChartsLegend position={{ vertical: 'bottom', horizontal: 'middle' }} />
          <ChartsTooltip />
          <ChartsAxisHighlight x="band" y="line" />
        </ResponsiveChartContainer>
      </Box>
    </BoxWithHeader>
  );
};
